<template>
  <div id="app">
    <MainView />
  </div>
</template>

<script>
import MainView from './components/main-view'

export default {
  name: 'app',
  components: {
    MainView
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
